<template>
    <layout-card :isCustomizable="settings.isCustomizable"
        :loading="loading"
        :type="settings.context"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-estimate_corp"
        :error="error"
        >
        <template #title>
            {{ name }}
        </template>

        <template #content>
            <template-kpi-card :data="{'stats': cardData, 'labels': labels}" />
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>

        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>
    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue';
    import TemplateKpiCard from './TemplateKpiCard.vue';
    import CardMixin from './CardMixin.js';
    import EstimateMixin from './EstimateMixin.js';
    import FiscalYearFooter from './FiscalYearFooter.vue'
    
    export default {
        mixins : [CardMixin, EstimateMixin],
        components: {
            LayoutCard,
            TemplateKpiCard,
            FiscalYearFooter,
            EstimateMixin
        }
    }
</script>